<template lang="pug">
  div
    validation-observer(ref='observer' tag='form')
      el-row.container(type="flex", justify="center", align="middle")
          el-card.box-card
            form(@keyup.enter="logar()")
              el-row(type="flex", justify="center")
                img.logo(src="../../../assets/images/logo.png")
              el-row(type="flex", justify="center")
                p Cadastrar/Redefinir Senha

              el-row(type="flex", justify="left", :gutter="30")
                el-col
                  validation-provider(rules="required|min:6", v-slot="{ errors }", name="senha")
                    el-input.input(
                      placeholder="Senha com no mínimo 6 caracteres",
                      type="password",
                      v-model.trim="senha",
                      :class="{'erro' : errors.length}",
                    )
                      i.fas.fa-key(
                        slot="suffix",
                      ).icon
                    span.help.erro {{ errors[0] }}
              el-row(type="flex", justify="start", :gutter="30")
                el-col
                  validation-provider(rules="required|password_confirmation:@senha", v-slot="{ errors }", name="confirmacaoSenha")
                    el-input.input(
                      placeholder="Confirmar senha",
                      type="password",
                      v-model.trim="confirmarSenha",
                      :class="{'erro' : errors.length}",
                    )
                      i.fas.fa-key(
                        slot="suffix",
                      ).icon
                    span.help.erro {{ errors[0] }}
            el-row(type="flex", justify="end", :gutter="30")
              el-button(
                @click="cadastrar()",
                ) Confirmar

</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      senha: '',
      confirmarSenha: '',
      codigo: ''
    }
  },

  created () {
    this.codigo = this.$route.params.codigo
  },

  methods: {
    ...mapActions({
      redefinirSenha: 'usuario/redefinirSenha'
    }),

    async cadastrar () {
      if (await this.$refs.observer.validate()) {
        await this.redefinirSenha({
          senha: this.senha,
          codigoAcesso: this.codigo
        })

        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Senha alterada com sucesso.')
        this.$router.push('/login')
      } else {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.PREENCHA_TODOS_CAMPOS)
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  @media screen and(min-width: 1023px) {
  .box-card {
    width: 30%;
  }
}

  .icon {
    margin-top: 10px;
    margin-right: 5px;
    font-size: 20px;
  }

  .key-success {
    color: #009f61;
  }

  .key-error {
    color: firebrick;
  }

  .logo {
    width: 80%;
    height: 100%;
  }

  .el-row {
    padding: 10px;
  }

  .container {
    height: 600px;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/CadastrarSenha.vue